<!--登录-->
<template>
  <div class="login">
    <div class="login-box">
      <div class="title_box">
        <img class="icon" src="../../assets/images/login_cart.png" />
        <span>自营新零售</span>
      </div>
      <div class="center_box">
        <span class="tag">┏</span>
        <span class="title1">属于自己的线上</span>
        <span class="title2"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;新零售店铺</span
        >
        <span class="tag tag2">┛</span>
      </div>
      <div class="trait_box">
        <img class="icon" src="../../assets/images/login_icon1.png" />
        <span class="txt">永久免费</span>
        <img class="icon" src="../../assets/images/login_icon2.png" />
        <span class="txt">快速开店</span>
        <img class="icon" src="../../assets/images/login_icon3.png" />
        <span class="txt">专有属性</span>
      </div>
      <div class="btn_open">免费开店</div>

      <div class="login-con" v-if="!data.mode_code && !data.mode_select_shop">
        <img
          class="switch"
          src="../../assets/images/login_change1.png"
          @click="switchMode"
        />
        <div class="login-header">
          <img
            v-if="data.mode_pwd"
            class="back"
            :src="data.icon_back"
            @mouseover="changeBack(true)"
            @mouseout="changeBack(false)"
          />
          <span v-if="!data.mode_find_pwd">{{
            data.mode_pwd ? "登录密码" : "登录店铺后台"
          }}</span>
          <span v-else>找回密码</span>
        </div>
        <div class="select_shop_text">已选择：{{ data.select_shop_name }}</div>
        <Form :model="data" ref="form" class="form">
          <FormItem
            prop="tel"
            class="form-row"
            v-if="!data.mode_pwd"
            :rules="rules.tel"
          >
            <div class="item">
              <Input
                class="myinput"
                v-model="data.tel"
                placeholder="请输入管理员账号"
              />
              <img class="ic_phone" src="../../assets/images/login_phone.png" />
            </div>
          </FormItem>
          <div class="warning" v-if="data.show_login_error">
            未查询到该账号关联的店铺信息
          </div>
          <FormItem
            prop="password"
            class="form-row"
            v-if="data.mode_pwd"
            :rules="rules.password"
          >
            <div class="item">
              <Input
                class="myinput"
                ref="password"
                type="password"
                v-model="data.password"
                placeholder="请输入登录密码"
                @on-enter="login"
              />
              <img class="ic_pwd" src="../../assets/images/login_pwd.png" />
            </div>
          </FormItem>
          <div class="btn_find_pwd" @click="findPwd">忘记密码？</div>
          <FormItem> </FormItem>
          <div class="bottom_box">
            <div class="btn_next" @click="clickNext" v-if="!data.mode_pwd">
              下一步
            </div>
            <div class="btn_next" @click="login" v-else>登录</div>
            <div class="agreement_box" v-if="!data.mode_pwd">
              <img class="icon" src="../../assets/images/login_select.png" />
              <span>我已阅读并同意《自营新零售服务条款》</span>
            </div>
          </div>
        </Form>
      </div>

      <div v-if="data.mode_code && !data.mode_select_shop" class="login-con">
        <img
          class="switch"
          src="../../assets/images/login_change2.png"
          @click="switchMode"
        />
        <div class="code_box">
          <img
            v-if="!scan_success"
            class="code"
            src="../../assets/images/code.png"
          />
          <div v-else>
            <img class="icon" src="../../assets/images/scan_success.png" />
            <div class="text">扫码成功</div>
          </div>
        </div>
        <div class="scan_text">微信扫一扫登录店铺后台</div>
      </div>

      <div v-if="data.mode_select_shop" class="login-con">
        <img
          class="switch"
          src="../../assets/images/login_change1.png"
          @click="switchMode"
        />
        <div class="login-header shop-header">
          <img
            class="back"
            :src="data.icon_back"
            @mouseover="changeBack(true)"
            @mouseout="changeBack(false)"
          />
          <span>选择登录店铺</span>
        </div>
        <div
          class="shop-item"
          :class="{ item_active: data.select_shop_id > 0 }"
          @click="onSelectShop"
        >
          <img class="icon" src="../../assets/images/login_shop.png" />
          <span class="name">为民办公官方店</span>
          <span class="role">(超级管理员)</span>
        </div>
        <div class="shop-item">
          <img class="icon" src="../../assets/images/login_shop.png" />
          <span class="name">为民办公官方店为民办公官方店</span>
          <span class="role">(管理员)</span>
        </div>
      </div>

      <div v-if="data.mode_find_pwd" class="login-con">
        <div class="find_top"></div>
        <div class="login-header">
          <img
            v-if="data.mode_pwd"
            class="back"
            :src="data.icon_back"
            @click="backFindPwd"
            @mouseover="changeBack(true)"
            @mouseout="changeBack(false)"
          />
          <span>找回密码</span>
        </div>
        <div class="select_shop_text">已选择：{{ data.select_shop_name }}</div>
        <Form :model="data" ref="form" class="form">
          <FormItem prop="tel" class="form-row" :rules="rules.tel" v-if="data.find_pwd_next">
            <div class="item">
              <Input
                class="myinput"
                v-model="data.tel"
                placeholder="请输入管理员手机号"
              />
              <img class="ic_phone" src="../../assets/images/login_phone.png" />
            </div>
          </FormItem>
          <FormItem prop="password" class="form-row" :rules="rules.password" v-if="data.find_pwd_next">
            <div class="item">
              <Input
                class="myinput"
                v-model="data.password"
                placeholder="请输入验证码"
                @on-enter="login"
              />
              <img class="ic_pwd" src="../../assets/images/login_pwd.png" />
              <span class="get_code" @click="getCode">获取验证码</span>
            </div>
          </FormItem>
           <FormItem prop="newpassword" class="form-row" :rules="rules.newpassword" v-if="!data.find_pwd_next">
            <div class="item">
              <Input
                class="myinput"
                v-model="data.newpassword"
                placeholder="请输入新密码"
                @on-enter="login"
              />
              <img class="ic_pwd" src="../../assets/images/login_pwd.png" />
            </div>
          </FormItem>
           <div class="bottom_box">
            <div class="btn_next" @click="clickFindPwdNext" v-if="data.find_pwd_next">
              下一步
            </div>
             <div class="btn_next" @click="clickFindPwdConfirm" v-else>
              完成
            </div>
          </div>
        </Form>
      </div>
    </div>
    <Modal
      v-model="modal.status"
      title="选择店铺"
      @on-ok="login"
      @onCancel="onCancel"
    >
      <RadioGroup v-model="data.shop_id" vertical>
        <Radio
          v-for="(item, index) in modal.data"
          :key="index"
          :label="item.shop_id"
        >
          <span>{{ item.shop_name }}（{{ item.role_name }}）</span>
        </Radio>
      </RadioGroup>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      modal: {
        data: [],
        status: false,
      },
      data: {
        tel: "",
        password: "",
        newpassword: "",
        shop_id: 0,
        mode_code: false, //二维码登录
        mode_select_shop: false, //选择店铺模式
        mode_pwd: true, //登录密码输入
        mode_find_pwd: false, //找回密码模式
        find_pwd_next:true,//找回密码第一步
        select_shop_id: 1,
        select_shop_name: "为民办公官方店(超级管理员)",
        scan_success: false,
        show_login_error: false,
        icon_back: require("../../assets/images/back.png"),
      },
      rules: {
        tel: [
          {
            required: true,
            type: "string",
            message: "请输入登录账号",
            trigger: "change",
          },
        ],
        password: [
          {
            required: true,
            type: "string",
            message: "请输入登录密码",
            trigger: "change",
          },
        ],
      },
    };
  },
  mounted() {},
  methods: {
    ...mapActions(["HandleLogin"]),
    clickNext() {
      console.log("点击了");
      this.$refs.form.validateField((tel, valid) => {
        console.log("cc" + valid);
      });
    },
    login() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.HandleLogin(this.data).then((res) => {
            if (res.status) {
              this.$router.push({ name: "home" });
            } else if (!res.status && res.code === 1) {
              this.$Message.info(res.msg);
              this.modal.data = res.data;
              this.modal.status = true;
              this.data.shop_id = 0;
            } else this.$Message.error(res.msg);
          });
        }
      });
    },
    onCancel() {
      this.modal.status = false;
      this.data.shop_id = 0;
    },
    switchMode() {
      if (this.data.mode_code) {
        this.data.mode_code = false;
      } else {
        this.data.mode_code = true;
      }
    },
    onSelectShop() {},

    changeBack(isHover) {
      if (isHover) {
        this.data.icon_back = require("../../assets/images/back_hover.png");
      } else {
        this.data.icon_back = require("../../assets/images/back.png");
      }
    },
    //找回密码
    findPwd() {
      this.data.mode_find_pwd = true;
    },
    //获取验证码
    getCode(){
      if(this.data.tel && this.data.tel.length==11){

      }else{
        this.$Message.error('请输入正确的手机号');
      }
    },
    //找回密码点击下一步
    clickFindPwdNext(){
      this.data.find_pwd_next = false;
    },
    //找回密码完成
    clickFindPwdConfirm(){

    },
    backFindPwd(){
      this.data.find_pwd_next = true;
    }
  },
};
</script>
<style lang="less" scoped>
@import "./login.less";
</style>
